import React, { Fragment, useEffect, useState } from "react";
// store
import { PAGINATION_LIMIT, API } from "../../../../store/config";
import moment from "moment";
import "moment/locale/sk";
// components
import { Table, Pagination, Icon, Card } from "semantic-ui-react";

// component
function StornoRecordsTable({ records }) {
    const [tableData, setTableData] = useState(
        records.slice(0, PAGINATION_LIMIT)
    );
    const [isMobile, setIsMobile] = useState(false);

    // set data to table
    useEffect(() => {
        setTableData(records.slice(0, PAGINATION_LIMIT));
    }, [records]);

    useEffect(() => {
        const media = window.matchMedia("(max-width: 768px)");
        const handleChange = () => setIsMobile(media.matches);
        handleChange();
        if (media.addEventListener) {
            media.addEventListener("change", handleChange);
        } else {
            media.addListener(handleChange);
        }
        return () => {
            if (media.removeEventListener) {
                media.removeEventListener("change", handleChange);
            } else {
                media.removeListener(handleChange);
            }
        };
    }, []);

    const handleChangePage = (event, data) => {
        setTableData(
            records.slice(
                data.activePage * PAGINATION_LIMIT - PAGINATION_LIMIT,
                data.activePage * PAGINATION_LIMIT
            )
        );
    };

    // template
    const totalPages = Math.ceil(records.length / PAGINATION_LIMIT) || 1;

    return (
        <Fragment>
            {isMobile ? (
                <div>
                    {tableData.length === 0 && (
                        <Card fluid style={{ borderRadius: "16px", textAlign: "center", boxShadow: "0 4px 16px rgba(0,0,0,0.06)", border: "1px solid rgba(0,0,0,0.06)" }}>
                            <Card.Content style={{ padding: "2rem 1rem" }}>
                                <div style={{ color: "rgba(0,0,0,0.4)", marginBottom: "0.5rem", display: "flex", justifyContent: "center" }}>
                                    <Icon name="inbox" style={{ fontSize: "2.5rem", margin: 0 }} />
                                </div>
                                <strong style={{ fontSize: "0.95rem", color: "rgba(0,0,0,0.7)", lineHeight: 1.4 }}>Vo zvolenom období neboli najdené žiadne záznamy</strong>
                            </Card.Content>
                        </Card>
                    )}
                    {tableData.map((record) => (
                        <Card key={record.id} fluid style={{ marginBottom: "1rem", borderRadius: "16px", overflow: "hidden", boxShadow: "0 4px 16px rgba(0,0,0,0.08)", border: "1px solid rgba(0,0,0,0.06)", background: "#fff" }}>
                            <Card.Content style={{ padding: "1rem 1.1rem", background: "linear-gradient(135deg, rgba(242,113,28,0.04) 0%, rgba(255,255,255,0) 100%)" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "0.8rem" }}>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ fontSize: "0.7rem", fontWeight: 600, color: "rgba(0,0,0,0.45)", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "0.25rem" }}>Aktivita</div>
                                        <div style={{ fontWeight: 700, fontSize: "1.05rem", color: "#1a1a1a", lineHeight: 1.3, marginBottom: "0.4rem" }}>{record.product?.event?.name}</div>
                                        <div style={{ fontSize: "0.8rem", color: "rgba(0,0,0,0.6)", fontWeight: 500 }}>
                                            <Icon name="map marker alternate" style={{ margin: "0 0.3rem 0 0", fontSize: "0.8rem" }} />
                                            {record.product?.event?.address}
                                        </div>
                                    </div>
                                    <div style={{ display: "inline-flex", justifyContent: "center", padding: "0.35rem 0.75rem", borderRadius: "20px", background: "#f2711c", color: "#fff", fontWeight: 700, fontSize: "0.75rem", lineHeight: 1.2, whiteSpace: "nowrap", boxShadow: "0 2px 8px rgba(242,113,28,0.25)", marginLeft: "0.5rem" }}>
                                        <Icon name="undo" style={{ margin: "0 0.3rem 0 0", fontSize: "0.85rem" }} />
                                        Refundácia
                                    </div>
                                </div>
                                <div style={{ fontSize: "0.85rem", color: "rgba(0,0,0,0.65)", fontWeight: 500 }}>
                                    <Icon name="calendar alternate outline" style={{ margin: "0 0.3rem 0 0", fontSize: "0.85rem" }} />
                                    {moment(record.product?.event?.starts).format("DD.MM.YYYY HH:mm")}
                                </div>
                            </Card.Content>
                            <Card.Content style={{ padding: "1rem 1.1rem", background: "#fafafa" }}>
                                <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "0.75rem", marginBottom: "0.75rem" }}>
                                    <div style={{ padding: "0.65rem 0.75rem", borderRadius: "12px", background: "#fff", border: "1px solid rgba(0,0,0,0.08)" }}>
                                        <div style={{ marginBottom: "0.4rem", paddingLeft: "0.15rem" }}>
                                            <Icon name="arrow down" style={{ margin: "0 0.3rem 0 0", fontSize: "0.75rem", color: "#f2711c" }} />
                                            <span style={{ fontSize: "0.7rem", color: "rgba(0,0,0,0.5)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.3px" }}>Vrátená suma</span>
                                        </div>
                                        <div style={{ fontWeight: 700, fontSize: "1.05rem", color: "#f2711c", paddingLeft: "0.15rem" }}>{record.storno_amount} EUR</div>
                                        <div style={{ fontSize: "0.7rem", color: "rgba(0,0,0,0.45)", paddingLeft: "0.15rem", marginTop: "0.2rem" }}>(70%)</div>
                                    </div>
                                    <div style={{ padding: "0.65rem 0.75rem", borderRadius: "12px", background: "#fff", border: "1px solid rgba(0,0,0,0.08)" }}>
                                        <div style={{ marginBottom: "0.4rem", paddingLeft: "0.15rem" }}>
                                            <Icon name="minus circle" style={{ margin: "0 0.3rem 0 0", fontSize: "0.75rem", color: "rgba(0,0,0,0.4)" }} />
                                            <span style={{ fontSize: "0.7rem", color: "rgba(0,0,0,0.5)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.3px" }}>Storno poplatok</span>
                                        </div>
                                        <div style={{ fontWeight: 700, fontSize: "1.05rem", color: "#1a1a1a", paddingLeft: "0.15rem" }}>{record.storno_remaining_amount} EUR</div>
                                        <div style={{ fontSize: "0.7rem", color: "rgba(0,0,0,0.45)", paddingLeft: "0.15rem", marginTop: "0.2rem" }}>(30%)</div>
                                    </div>
                                    <div style={{ padding: "0.65rem 0.75rem", borderRadius: "12px", background: "#fff", border: "1px solid rgba(0,0,0,0.08)" }}>
                                        <div style={{ marginBottom: "0.4rem", paddingLeft: "0.15rem" }}>
                                            <Icon name="tag" style={{ margin: "0 0.3rem 0 0", fontSize: "0.75rem", color: "rgba(0,0,0,0.4)" }} />
                                            <span style={{ fontSize: "0.7rem", color: "rgba(0,0,0,0.5)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.3px" }}>Pôvodná cena</span>
                                        </div>
                                        <div style={{ fontWeight: 700, fontSize: "1.05rem", color: "#1a1a1a", paddingLeft: "0.15rem" }}>{record.product.price} EUR</div>
                                    </div>
                                    <div style={{ padding: "0.65rem 0.75rem", borderRadius: "12px", background: "#fff", border: "1px solid rgba(0,0,0,0.08)" }}>
                                        <div style={{ marginBottom: "0.4rem", paddingLeft: "0.15rem" }}>
                                            <Icon name="calendar check" style={{ margin: "0 0.3rem 0 0", fontSize: "0.75rem", color: "rgba(0,0,0,0.4)" }} />
                                            <span style={{ fontSize: "0.7rem", color: "rgba(0,0,0,0.5)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.3px" }}>Refundované</span>
                                        </div>
                                        <div style={{ fontWeight: 700, fontSize: "0.85rem", color: "#1a1a1a", paddingLeft: "0.15rem" }}>
                                            {record.storno_when ? moment(record.storno_when).format("DD.MM.YYYY") : "-"}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ padding: "0.75rem", borderRadius: "12px", background: "#fff", border: "1px solid rgba(0,0,0,0.08)" }}>
                                    <div style={{ marginBottom: "0.4rem", paddingLeft: "0.15rem" }}>
                                        <Icon name="user" style={{ margin: "0 0.3rem 0 0", fontSize: "0.75rem", color: "rgba(0,0,0,0.4)" }} />
                                        <span style={{ fontSize: "0.7rem", color: "rgba(0,0,0,0.5)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.3px" }}>Zákazník</span>
                                    </div>
                                    <div style={{ fontWeight: 700, fontSize: "0.9rem", color: "#1a1a1a", paddingLeft: "0.15rem", marginBottom: "0.3rem" }}>
                                        {record.storno_by?.firstname} {record.storno_by?.lastname}
                                    </div>
                                    <a href={`mailto:${record.storno_by?.email}`} style={{ fontSize: "0.8rem", color: "var(--primary)", paddingLeft: "0.15rem", textDecoration: "none" }}>
                                        {record.storno_by?.email}
                                    </a>
                                </div>
                            </Card.Content>
                            <Card.Content style={{ padding: "0.75rem 1.1rem", background: "#fff", borderTop: "1px solid rgba(0,0,0,0.08)" }}>
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.75rem" }}>
                                    <a href={API.STORNO + "records/" + record.id + '/docs/'} target="_blank" rel="noopener noreferrer" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem", padding: "0.65rem", background: "var(--primary)", color: "#fff", fontWeight: 700, fontSize: "0.9rem", textDecoration: "none", borderRadius: "8px", lineHeight: 1 }}>
                                        <Icon name="file pdf" style={{ margin: 0, fontSize: "1rem" }} />
                                        <span>Faktúra</span>
                                    </a>
                                    <a href={API.STORNO + record.id + '/docs/'} target="_blank" rel="noopener noreferrer" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem", padding: "0.65rem", background: "#555", color: "#fff", fontWeight: 700, fontSize: "0.9rem", textDecoration: "none", borderRadius: "8px", lineHeight: 1 }}>
                                        <Icon name="file pdf" style={{ margin: 0, fontSize: "1rem" }} />
                                        <span>Dobropis</span>
                                    </a>
                                </div>
                            </Card.Content>
                        </Card>
                    ))}
                    {totalPages > 1 && (
                        <div style={{ display: "flex", justifyContent: "center", marginTop: "1.5rem", marginBottom: "1rem" }}>
                            <Pagination
                                defaultActivePage={1}
                                totalPages={totalPages}
                                onPageChange={handleChangePage}
                                boundaryRange={0}
                                siblingRange={1}
                            />
                        </div>
                    )}
                </div>
            ) : (
                <Card fluid style={{ borderRadius: "8px", boxShadow: "none", border: "1px solid #e0e0e0" }}>
                    <Card.Content style={{ padding: "0.5rem 0.75rem" }}>
                        <div style={{ overflowX: "auto" }}>
                            <Table striped unstackable style={{ minWidth: "1200px" }}>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell textAlign="left">Dátum refundácie</Table.HeaderCell>
                                        <Table.HeaderCell>Aktivita / Termín</Table.HeaderCell>
                                        <Table.HeaderCell>Zákazník</Table.HeaderCell>
                                        <Table.HeaderCell>Vrátna suma (70%)</Table.HeaderCell>
                                        <Table.HeaderCell>Storno poplatok (30%)</Table.HeaderCell>
                                        <Table.HeaderCell>Pôvodna cena termínu</Table.HeaderCell>
                                        <Table.HeaderCell textAlign="left">Faktúra a zápočet</Table.HeaderCell>
                                        <Table.HeaderCell textAlign="left">Dobropis</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {tableData.length === 0 &&
                                        <Table.Row>
                                            <Table.Cell colSpan={8} style={{ textAlign: "center", fontWeight: "bold" }}>
                                                Vo zvolenom období neboli najdené žiadne záznamy
                                            </Table.Cell>
                                        </Table.Row>
                                    }
                                    {tableData.map((record) => (
                                        <Table.Row key={record.id}>
                                            <Table.Cell textAlign="left">
                                                {record.storno_when ? moment(record.storno_when).format("DD.MM.YYYY") : "-"}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {record.product?.event?.name} - {moment(record.product?.event?.starts).format("DD.MM.YYYY HH:mm")} <br />
                                                <span style={{ fontSize: "0.9rem" }}>Miesto konania: <strong>{record.product?.event?.address}</strong> </span>
                                            </Table.Cell>
                                            <Table.Cell>
                                                {record.storno_by?.firstname} {record.storno_by?.lastname} <br />
                                                <span style={{ opacity: 0.8 }}> <a style={{ color: "var(--primary)" }} href={`mailto:${record.storno_by?.email}`} > {record.storno_by?.email}</a> </span>
                                            </Table.Cell>
                                            <Table.Cell>
                                                <span> {record.storno_amount} EUR</span>
                                            </Table.Cell>
                                            <Table.Cell>
                                                <span> {record.storno_remaining_amount} EUR</span>
                                            </Table.Cell>
                                            <Table.Cell>
                                                <span> {record.product.price} EUR</span> <br />
                                                <span style={{ fontSize: "0.9rem" }}>Zakúpené: <strong>{moment(record.product?.created).format("DD.MM.YYYY")}</strong></span>
                                            </Table.Cell>
                                            <Table.Cell textAlign="left">
                                                <a href={API.STORNO + "records/" + record.id + '/docs/'} target="_blank" rel="noopener noreferrer">
                                                    <Icon name="file pdf" style={{ color: "red", fontSize: "1.2rem" }} />
                                                    <span style={{ fontWeight: "bold", color: "black" }}>Zobraziť</span>
                                                </a>
                                            </Table.Cell>
                                            <Table.Cell textAlign="left">
                                                <a href={API.STORNO + record.id + '/docs/'} target="_blank" rel="noopener noreferrer">
                                                    <Icon name="file pdf" style={{ color: "red", fontSize: "1.2rem" }} />
                                                    <span style={{ fontWeight: "bold", color: "black" }}>Zobraziť</span>
                                                </a>
                                            </Table.Cell>
                                        </Table.Row>
                                    ))}
                                </Table.Body>

                                <Table.Footer>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan="8">
                                            <Pagination
                                                defaultActivePage={1}
                                                totalPages={totalPages}
                                                onPageChange={handleChangePage}
                                                boundaryRange={0}
                                                siblingRange={0}
                                            />
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Footer>
                            </Table>
                        </div>
                    </Card.Content>
                </Card>
            )}
        </Fragment>
    );
}

export default StornoRecordsTable;
